import React, { useState, useEffect } from 'react'
import s from './style.module.css'
import useVizualisation from '../../helpers/useVizualisation'
import { Scrollama, Step } from 'react-scrollama'

const ProgressScroller = ({ vizElement: Viz, scenes = [], ...rest }) => {
  const { ref, windowSize, height, inView } = useVizualisation()

  const [vizProps, setVizProps] = useState(rest)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    window.dispatchEvent(new Event('resize'))
  }, [inView])

  return (
    <div className={s.wrap}>
      <div
        className={s.viz}
        style={{
          '--top-space': `${(windowSize.height - height) / 2}px`
        }}
      >
        <div className={s.inner} ref={ref}>
          <Viz {...rest} {...vizProps} progress={progress} />
        </div>
      </div>

      <Scrollama
        offset={0.7}
        progress={true}
        onStepProgress={({ element, data, progress }) => {
          setProgress(progress)
        }}
        onStepEnter={({ elem, data }) => {
          setVizProps(data)
        }}
        debug={false}
      >
        {scenes.map((scene, i) => {
          return (
            <Step
              data={{ ...scene, scrollerNum: i, index: i }}
              key={`scene-${i}`}
            >
              <div className={s.scene}>
                <div className={s.text}>
                  <p dangerouslySetInnerHTML={{ __html: scene.text }} />
                </div>
              </div>
            </Step>
          )
        })}
      </Scrollama>
    </div>
  )
}

export default ProgressScroller
